var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreaking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.9,53.4L41.1,67.1V43.7c0-1.3-0.5-2.6-1.5-3.6c-2-2-5.3-2-7.3,0c-1,1-1.5,2.3-1.5,3.6v84.9c0,2.8,2.3,5.1,5.1,5.1 s5.1-2.3,5.1-5.1V99.8l30.1-30.1L54.9,53.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3,
    cy: 84.9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6,55.8H79.2l-44-44c-2-2-5.3-2-7.3,0s-2,5.3,0,7.3l47,47h53.7c2.8,0,5.1-2.3,5.1-5.1 C133.7,58.1,131.4,55.8,128.6,55.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreaking);
export default __webpack_public_path__ + "static/media/breaking.4624a50ce71181fb106a3c6991dbbd15.svg";
export { ForwardRef as ReactComponent };